import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useForm } from 'react-hook-form';
import { Form, Row, Col } from 'react-bootstrap';
import { isMobile } from 'react-device-detect';

import { theme } from '_constants/theme';
import { FIELDS_KEYS } from '_constants/forms';
import { getFieldProps } from '_helpers/forms/fields';

import Card from '_components/atomic/layouts/Card';
import BaseField from '_components/atomic/fields/BaseField';
import TextareaField from '_components/atomic/fields/TextareaField';
import Button from '_components/atomic/Button';

const StyledForm = styled(Form)`
  width: 100%;
  max-width: 600px;

  @media ${theme.devices.tablet} {
    max-width: unset;
  }
`;

const ContactUsForm = ({ error, success, submitDisabled, onSubmit }) => {
  const {
    control,
    formState: { isValidating },
    reset,
    handleSubmit,
  } = useForm({
    reValidateMode: 'onBlur',
  });

  const [emailVerifying, setEmailVerifying] = useState(false);

  useEffect(() => {
    if (success) {
      reset();
    }
  }, [success, reset]);

  return (
    <StyledForm noValidate onSubmit={handleSubmit(onSubmit)}>
      <Card hiddenBorder={isMobile}>
        <Card.Body innerSpace={isMobile ? 0 : undefined}>
          <BaseField
            {...getFieldProps(FIELDS_KEYS.fullName)}
            bottomSpace={theme.spaces.regular}
            control={control}
          />
          <BaseField
            {...getFieldProps(FIELDS_KEYS.email, {
              validationOptions: { setProcessing: setEmailVerifying },
            })}
            control={control}
            loading={emailVerifying}
            feedback={emailVerifying ? 'Verifying...' : undefined}
            bottomSpace={theme.spaces.regular}
          />
          <BaseField
            {...getFieldProps(FIELDS_KEYS.subject)}
            bottomSpace={theme.spaces.regular}
            control={control}
          />
          <TextareaField
            {...getFieldProps(FIELDS_KEYS.message)}
            bottomSpace={theme.spaces.regular}
            control={control}
          />
          <Row>
            <Col xs={12} md={2} />
            <Col xs={12} md={8}>
              <Button
                type="submit"
                disabled={emailVerifying || isValidating || submitDisabled}
              >
                Send Message
              </Button>
            </Col>
            <Col xs={12} md={2} />
          </Row>
        </Card.Body>
      </Card>

      {success && (
        <Card.Text
          color={theme.colors.gray[500]}
          weight={600}
          topSpace={theme.spaces.large}
        >
          Thank you for your question. Our agents will respond to your inquiry
          as quickly as possible.
        </Card.Text>
      )}
      {error && (
        <Card.Text
          color={theme.colors.orange[500]}
          weight={600}
          topSpace={theme.spaces.large}
        >
          {error?.message}
        </Card.Text>
      )}
    </StyledForm>
  );
};

ContactUsForm.propTypes = {
  error: PropTypes.object,
  submitDisabled: PropTypes.bool,
  onSubmit: PropTypes.func,
};

export default ContactUsForm;
